var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"outer-footer-container"}},[_c('div',{attrs:{"id":"footer-container"}},[_vm._v(" Contact: "),_c('a',{attrs:{"href":"mailto:info@ben-smith-development.com"}},[_vm._v(" info@ben-smith-development.com")])])])
}]

export { render, staticRenderFns }